<template>
  <div class="container">
    <hr />
    <div class="form-elements">
      <form>
        <va-card>
          <div class="flex xs12 md12 lg12">
            <div class="row">
              <div class="flex md6 xs12">
                <va-input
                  label="Form Title"
                  name="form-title"
                  v-model="formTitle"
                  placeholder="Form Title"
                ></va-input>
              </div>

              <div class="flex md6 xs12">
                <va-select
                  label="Select Consent"
                  v-model="selected"
                  keyBy="_id"
                  :options="fitleredConsents"
                  noOptionsText="All consents are assigned to a form"
                  textBy="consentTitle"
                ></va-select>

                <va-button
                  class="pull-right"
                  color="success"
                  v-if="selected"
                  :disabled="selected == ''"
                  @click.prevent="addConsent"
                  >Add Consent</va-button
                >
              </div>
            </div>

            <div class="flex md12 xs12">
              <va-input
                label="Form Question"
                name="form-question"
                type="textarea"
                v-model="formQuestion"
                placeholder="Form Question"
              ></va-input>
            </div>
          </div>
        </va-card>

        <hr />
        <va-card v-if="selectedConsents.length > 0" title="Consents">
          <consent-grid
            @consentRowDeleted="removeRow"
            :consents="formConsents"
          ></consent-grid>
        </va-card>
      </form>
    </div>

    <div class="pull-right">
      <va-button @click="cancel" color="warning">Cancel</va-button>
      <va-button :disabled="formTitle == ''" @click="create" color="success"
        >Submit</va-button
      >
    </div>
  </div>
</template>

<script>
import consentGrid from "./FormConsentGrid.vue";
import consentService from "../../consents/consentsService.js";
import formsService from "../ConsentFormsService.js";

export default {
  data() {
    return {
      consents: [],
      formTitle: "",
      formQuestion: "",
      selectedConsents: [],
      selected: ""
    };
  },
  computed: {
    formConsents() {
      return this.selectedConsents;
    },
    fitleredConsents() {
      return this.consents;
    }
  },
  components: {
    consentGrid
  },
  methods: {
    addConsent() {
      let index;
      this.selectedConsents.push(this.selected);
      this.consents.filter(consent => {
        if (consent._id === this.selected._id) {
          index = this.consents.indexOf(consent);
        }
      });

      this.consents.splice(index, 1);
      this.selected = "";
    },
    removeRow(consent) {
      const idx = this.selectedConsents.findIndex(c => c._id === consent._id);
      this.consents.push(consent);

      this.selectedConsents.splice(idx, 1);
    },

    create() {
      let form = {
        formTitle: this.formTitle,
        formQuestion: this.formQuestion
      };

      if (this.formConsents.length > 0) {
        form.formConsents = [];
        this.formConsents.forEach(consent => {
          form.formConsents.push({
            consentId: consent._id
          });
        });
      }

      formsService
        .createForm(form)
        .then(rest => {
          this.$toasted.success("Form Created Succesfully", {
            icon: "fa-check",
            position: "top-right",
            duration: 2000,
            fullWidth: false
          });
          this.$router.push("/");
        })
        .catch(error => {
          const message =
            error.response.data.message == undefined
              ? "Something went wrong"
              : error.response.data.message;

          this.$toasted.error(message, {
            icon: "fa-close",
            position: "top-right",
            duration: 2000,
            fullWidth: false
          });
        });
      
    },
    cancel() {
      this.$router.push({ name: "consentForms" });
    }
  },
  created() {
    consentService.isInForm({ mode: false }).then(result => {
      let data = result.data.titleAndFormIdConsentDTOS;

      if (data) {
        data.forEach(consentDTO => {
          this.consents.unshift(consentDTO);
        });
      }
    });
  }
};
</script>
